module.exports = __webpack_public_path__ + "static/media/tron.e1415fbc.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/payment/networks/tron.svg
// module id = 427
// module chunks = 7